export default "__VITE_ASSET__Daf3iQFW__"